export const getUnprefixedRedirectRoutePaths = (
  defaultPaths: readonly string[],
  additionalPaths: readonly string[] = [],
): string[] => [...new Set([...defaultPaths, ...additionalPaths])];
